import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { formatFullDate } from '../../utils/dateUtils';
import { MyEventStateModel, MyEventModel } from '../../types';

const initialMyEventState: MyEventStateModel = {
  allEvents: [],
  loaded: false,
  status: false,
  numOfRecords: -1,
};

const myEventSlice = createSlice({
  name: 'myEvent',
  initialState: initialMyEventState,
  reducers: {
    setMyEvents(state, action: PayloadAction<any>) {
      action.payload.data.events.map((event: MyEventModel) => {
        if (event?.event) {
          event.event.date = new Date(event.event.eventDate.start);
          event.event.displayDate = formatFullDate(event.event.eventDate.start);
        }
        event.registrationDate = new Date(event.createdDate || '');
        event.registrationDisplayDate = formatFullDate(event.createdDate || '');
        return event;
      });

      // sort
      action.payload.data.events.sort((a: any, b: any) =>
        0 - a.event.date.getTime() < b.event.date.getTime() ? -1 : 1,
      );

      state.allEvents = action.payload.data.events;
      state.loaded = true;
      state.numOfRecords = action.payload.data.events.length;
    },
    appendMyEvent(state, action: PayloadAction<any>) {
      console.log('Append my event');
      let newEvent: MyEventModel = action.payload.data.event;
      if (newEvent.event) {
        newEvent.event.date = new Date(newEvent.event.eventDate.start);
        newEvent.event.displayDate = formatFullDate(newEvent.event.eventDate.start);
      }
      newEvent.registrationDate = new Date(newEvent.createdDate || '');
      newEvent.registrationDisplayDate = formatFullDate(newEvent.createdDate || '');

      state.allEvents = [...state.allEvents, ...[newEvent]];

      // sort
      state.allEvents.sort((a: any, b: any) => (0 - a.event.date.getTime() < b.event.date.getTime() ? -1 : 1));

      state.loaded = true;
      state.numOfRecords = state.allEvents.length;
    },
    setRegistrationStatus(state, action: PayloadAction<any>) {
      state.status = action.payload.status;
    },
    clearMyEvents(state) {
      state.allEvents = [];
      state.numOfRecords = -1;
    },
  },
});

export default myEventSlice;
